import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'


export default class AuditTrailAPI {

    static CreateAuditTrail(payload) {
        return new Promise(((resolve, reject) => {
            Axios.Post(url.audit_trail.save_user_log_activity, payload)
            .then((result) => {
                resolve(result)
            }, (err) => {
                reject(err)
            })
        }))
    }
}